export const SET_TOGGLE_ARRAY = 'SET_TOGGLE_ARRAY';
export const SET_DRAW_TOTAL = 'SET_DRAW_TOTAL';

export const setToggleArray = (state) => (dispatch) => {
    dispatch({ type: SET_TOGGLE_ARRAY, state });
};

export const setDrawTotal = (state) => (dispatch) => {
    dispatch({ type: SET_DRAW_TOTAL, state });
};

export default {
    SET_TOGGLE_ARRAY,
    setToggleArray,
    SET_DRAW_TOTAL,
    setDrawTotal,
};
